import store from '@/store'

let guard = (context) => new Promise((resolve, reject) => {

  if (!store.getters['auth/user'] || !store.getters['auth/user'].id) {
    resolve()
  } else {
    reject({
      name: 'dashboard',
    })
  }
})

export default {
  name: 'guest',
  run: guard
}
